import en_US from "./en_US";

const messages = {
  ...en_US,
  Edit: "Bewerken",
  Save: "Opslaan",
  Delete: "Verwijderen",
  Cancel: "Annuleren",
  Configuration: "Configuratie",
  Enhancers: "Verrijkers",
  "Edit Node Sources": "Nodebronnen bewerken",
  "Edit Nodes": "Nodes bewerken",
  "edit.nodes.header": "Nodes bewerken",
  "Add a new Node Source": "Nieuwe nodebron toevoegen",
  "add.node.source": "Nieuwe nodebron toevoegen",
  "Add a new Node Enhancer": "Nieuwe node-enhancer toevoegen",
  "add.node.enhancer": "Nieuwe node-enhancer toevoegen",
  "Node Sources for the project. Sources are loaded in the defined order, with later sources overriding earlier sources. (You can use ${project.name} inside configuration values to substitute the project name.)":
    "Nodebronnen voor het project. Bronnen worden in de opgegeven volgorde geladen; latere bronnen overschrijven eerdere bronnen. (Gebruik ${project.name} in configuratiewaarden om de projectnaam in te voegen.)",
  "Node Sources for the project. Sources are loaded in the defined order, with later sources overriding earlier sources. (You can use  {'${project.name}'} inside configuration values to substitute the project name.)":
    "Nodebronnen voor het project. Bronnen worden in de opgegeven volgorde geladen; latere bronnen overschrijven eerdere bronnen. (Gebruik ${project.name} in configuratiewaarden om de projectnaam in te voegen.)",
  "Node Enhancers can modify the data loaded from Node Sources.":
    "Node-enhancers kunnen de gegevens wijzigen die vanuit nodebronnen zijn geladen.",
  "framework.service.NodeEnhancer.explanation":
    "Node-enhancers kunnen de gegevens wijzigen die vanuit nodebronnen zijn geladen.",
  "framework.service.NodeEnhancer.label.short.plural": "Verrijkers",
  "project.node.sources.title.short": "Bronnen",
  "project.node.sources.title": "Nodebronnen",
  "modifiable.node.sources.will.appear.here":
    "Aanpasbare nodebronnen verschijnen hier.",
  "no.modifiable.sources.found": "Geen wijzigbare bronnen gevonden",
  "use.the.node.sources.tab.1": "Gebruik het ",
  "use.the.node.sources.tab.2": "tabblad om uw nodebronnen bij te werken.",
  "empty.message.default": "Niets geconfigureerd. Klik op {0} om een nieuwe plugin toe te voegen.",
  "None configured. Click ResourceModelSource to add a new plugin.":
    "Niets geconfigureerd. Klik op ResourceModelSource om een nieuwe plugin toe te voegen.",
  "None configured. Click NodeEnhancer to add a new plugin.":
    "Niets geconfigureerd. Klik op NodeEnhancer om een nieuwe plugin toe te voegen.",
  "none.configured.click.plugin.to.add.a.new.plugin":
    "Niets geconfigureerd. Klik op {0} om een nieuwe plugin toe te voegen.",
  "Scans a directory and loads all resource document files":
    "Scant een map en laadt alle resource-documentbestanden",
  "Reads a file containing node definitions in a supported format":
    "Leest een bestand met nodedefinities in een ondersteund formaat",
  "Provides the local node as the single resource":
    "Gebruikt de lokale node als enige resource",
  "Run a script to produce resource model data":
    "Voer een script uit om resource-modeldata te genereren",
  "Retrieves a URL containing node definitions in a supported format":
    "Haalt een URL op met nodedefinities in een ondersteund formaat",
  "Display the Project Readme": "Project-Readme tonen",
  "Display the Project MOTD": "Project-MOTD tonen",
  "Allow Unsanitized HTML output": "Niet-geschoonde HTML-uitvoer toestaan",
  "Projects List": "Projectlijst",
  "Project Home Page": "Project-startpagina",
  "Navbar Indicator": "Navigatiebalk-indicator",
  "Job Group Expansion Level": "Uitvouwdiepte van jobgroepen",
  "Enable/Disable Execution Now": "Uitvoering nu in-/uitschakelen",
  "Disable Execution": "Uitvoering uitschakelen",
  "Disable Schedule": "Planning uitschakelen",
  "Enable/Disable Execution Later": "Uitvoering later in-/uitschakelen",
  "Disable Execution after time": "Uitvoering uitschakelen na tijd",
  "Time to disable execution : {0}": "Tijd tot uitschakelen van uitvoering: {0}",
  "Enable/Disable Schedule Later": "Planning later in-/uitschakelen",
  "Disable Scheduled after Time": "Planning uitschakelen na tijd",
  "Time to disable schedule : {0}": "Tijd tot uitschakelen van planning: {0}",
  "Use Asynchronous Cache": "Asynchrone cache gebruiken",
  "Use asynchronous cache for all Node Source results in this project":
    "Gebruik asynchrone cache voor alle Node Source-resultaten in dit project",
  "Cache Delay": "Cachevertraging",
  "Delay in seconds, at least 30.": "Vertraging in seconden, minimaal 30.",
  "Synchronous First Load": "Synchrone eerste laadactie",
  "When the cache is empty, forces the first load to happen synchronously to prevent empty node results.":
    "Wanneer de cache leeg is, wordt de eerste laadactie synchroon uitgevoerd om lege noderesultaten te voorkomen.",
  "More...": "Meer...",
  Yes: "Ja",
  No: "Nee",
  "storage.enter.path": "Voer een pad in",
  "storage.enter.password": "Voer een wachtwoord in",
  "storage.enter.directory.name": "Voer de mapnaam in",
  "storage.specify.name": "Geef een naam op.",
  "soft.wrap": "Regelafbreking",
  cancel: "Annuleren",
  "button.action.Cancel": "Annuleren",
  "Search Activity": "Activiteit zoeken",
  Any: "Alle",
  "Any Time": "Altijd",
  "Other...": "Anders...",
  "Save as a Filter...": "Opslaan als filter...",
  "job.filter.save.button.title": "Opslaan als filter...",
  add: "toevoegen",
  Search: "Zoeken",
  search: "Zoeken",
  message_pageFilterBtnSearch: "Zoeken",
  "job.filter.quick.placeholder": "Zoeken",
  "job.filter.apply.button.title": "Zoeken",
  "filter.jobs": "Jobs zoeken",
  "search.ellipsis": "Zoeken...",
  "execute.locally": "Lokaal uitvoeren",
  "dispatch.to.nodes": "Uitvoeren op nodes",
  "schedule.to.run.repeatedly": "Herhaald plannen?",
  "scheduledExecution.property.scheduleEnabled.label": "Planning inschakelen?",
  "scheduledExecution.property.scheduleEnabled.description":
    "Deze job plannen toestaan?",
  "scheduledExecution.property.executionEnabled.label": "Uitvoering inschakelen?",
  "scheduledExecution.property.executionEnabled.description":
    "Deze job uitvoeren toestaan?",
  "notification.event.onstart": "Bij start",
  "notification.event.onsuccess": "Bij succes",
  "notification.event.onfailure": "Bij fout",
  "notification.event.onretryablefailure": "Bij herhaalbare fout",
  "notification.event.onavgduration": "Gemiddelde duur overschreden",
  "scheduledExecution.property.notifyAvgDurationThreshold.label": "Drempel",
  jobAverageDurationPlaceholder: "leeg laten voor gemiddelde jobduur",
  none: "Geen",
  browse: "Bladeren",
  result: "Resultaat:",
  actions: "Acties",
  filters: "Filters",
  "resource.metadata.entity.tags": "Tags",
  "enter.a.node.filter": "Voer een nodefilter in, of .* voor alle nodes",
  "run.a.command.on.count.nodes.ellipsis":
    "Een opdracht uitvoeren op {0} {1}",
  "create.a.job.for.count.nodes.ellipsis": "Een job maken voor {0} {1}",
  "all.nodes": "Alle nodes",
  "all.nodes.menu.item": "-Alle nodes-",
  "no.nodes.selected.match.nodes.by.selecting.or.entering.a.filter":
    "Geen nodes geselecteerd. Selecteer nodes door een filter te kiezen of in te voeren.",
  "jobquery.title.titleFilter": "Adhoc-opdracht",

  message_cancel: "Annuleren",
  message_webhookPageTitle: "Webhooks",
  message_webhookListTitle: "Webhooks",
  message_webhookDetailTitle: "Webhook-details",
  message_webhookListNameHdr: "Naam",
  message_addWebhookBtn: "Toevoegen",
  message_webhookEnabledLabel: "Ingeschakeld",
  message_webhookPluginCfgTitle: "Pluginconfiguratie",
  message_webhookSaveBtn: "Opslaan",
  message_webhookCreateBtn: "Webhook maken",
  message_webhookDeleteBtn: "Verwijderen",
  message_webhookPostUrlLabel: "POST-URL",
  message_webhookPostUrlHelp:
    "Wanneer een HTTP POST-verzoek naar deze URL wordt ontvangen, ontvangt de hieronder gekozen Webhook-plugin de data.",
  message_webhookPostUrlPlaceholder:
    "URL wordt gegenereerd nadat de Webhook is gemaakt",
  message_webhookNameLabel: "Naam",
  message_webhookUserLabel: "Gebruiker",
  message_webhookUserHelp:
    "De autorisatiegebruikersnaam die wordt gebruikt bij het uitvoeren van deze webhook. Alle ACL-beleidsregels die overeenkomen met deze gebruikersnaam worden toegepast.",
  message_webhookRolesLabel: "Rollen",
  message_webhookRolesHelp:
    "De autorisatierollen die worden gebruikt bij het uitvoeren van deze webhook (komma-gescheiden). Alle ACL-beleidsregels die overeenkomen met deze rollen worden toegepast.",
  message_webhookAuthLabel: "HTTP-autorisatietekenreeks",
  message_webhookGenerateSecurityLabel: "Autorisatieheader gebruiken",
  message_webhookGenerateSecretCheckboxHelp:
    "[Optioneel] Een Webhook-autorisatietekenreeks kan worden gegenereerd om de beveiliging van deze webhook te verhogen. Alle POST-verzoeken moeten de gegenereerde tekenreeks in de Authorization-header bevatten.",
  message_webhookSecretMessageHelp:
    "Kopieer deze autorisatietekenreeks nu. Nadat je deze webhook verlaat, kun je de tekenreeks niet meer zien.",
  message_webhookRegenClicked:
    "Er wordt een nieuwe autorisatietekenreeks gegenereerd en getoond wanneer de webhook is opgeslagen.",
  message_webhookPluginLabel: "Kies Webhook-plugin",
  message_webhookFilterListPlaceholder: "Webhooks filteren",
  message_webhookTabGeneral: "Algemeen",
  message_webhookTabHandlerConfiguration: "Handlerconfiguratie",
  message_webhookButtonRegenerate: "Opnieuw genereren",
  message_webhookNewHookName: "Nieuwe Webhook",

  "Workflow.strategy.description.node-first":
    "Voer alle stappen op een node uit voordat je naar de volgende node gaat.",
  "Workflow.step.label.add": "Stap toevoegen",
  "Workflow.step.label.choose.the.type": "Klik op een staptype om toe te voegen.",
  "step.type.jobreference.title": "Job Reference",
  "step.type.jobreference.nodestep.description":
    "Voer nog een job uit voor elke node",
  "scheduledExecution.property.logOutputThresholdAction.label":
    "Actie bij loglimiet",
  "scheduledExecution.property.logOutputThresholdAction.halt.label":
    "Stop met status:",
  "scheduledExecution.property.logOutputThresholdAction.truncate.label":
    "Afkappen en doorgaan",
  "scheduledExecution.property.logOutputThreshold.label": "Loguitvoerlimiet",
  "util.undoredo.undo": "Ongedaan maken",
  "util.undoredo.redo": "Opnieuw",
  resourcesEditor: {
    ...en_US.resourcesEditor,
    "Dispatch to Nodes": "Uitvoeren op nodes",
    Nodes: "Nodes",
  },
  Workflow: {
    ...en_US.Workflow,
    addStep: "Stap toevoegen",
    logFilters: "Logfilters",
    addLogFilter: "Logfilter toevoegen",
    clickToEdit: "Klik om te bewerken",
    edit: "Bewerken",
    duplicateStep: "Dupliceer deze stap",
    itemControls: "Itembediening",
    deleteThisStep: "Verwijder deze stap",
    dragToReorder: "Sleep om te herschikken",
    clickOnStepType: "Klik op een staptype om toe te voegen",
    editStep: "Stap bewerken",
    stepLabel: "Staplabel",
    noSteps: "Geen workflow-stappen",
    addErrorHandler: "Fouthandler toevoegen",
    errorHandler: "Fouthandler",
    errorHandlerDescription: "De fouthandler wordt uitgevoerd als de stap mislukt.",
    editErrorHandler: "Fouthandler bewerken",
  },
  notifications: {
    ...en_US.notifications,
    helpText:
      "Meldingen kunnen door verschillende gebeurtenissen tijdens de jobuitvoering worden geactiveerd.",
    emptyText:
      "Er zijn geen meldingen gedefinieerd. Klik op een gebeurtenis hieronder om een melding toe te voegen.",
    addButton: "Melding toevoegen",
    triggerLabel: "Trigger",
    selectTrigger: "Selecteer een trigger",
    typeLabel: "Meldingstype",
    selectNotification: "Selecteer een melding",
  },
  "results.empty.text": "Geen resultaten voor deze zoekopdracht",
  "filter.save.button": "Filter opslaan...",
  "save.filter.ellipsis": "Filter opslaan",
  "job.list.filter.save.modal.title": "Filter opslaan",
  "job.list.filter.save.button": "Filter opslaan",
  "Save Filter": "Filter opslaan",
  period: {
    ...en_US.period,
    label: {
      ...(en_US.period?.label || {}),
      All: "altijd",
      Hour: "in het afgelopen uur",
      Day: "in de afgelopen dag",
      Week: "in de afgelopen week",
      Month: "in de afgelopen maand",
    },
  },
};

export default messages;
